import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

import { CorporateFiltersBarComponent } from '../corporate-filters-bar/corporate-filters-bar.component';
import { CorporateReportingStoreService } from '../../../services/stores/corporate-reporting-store.service';
import { OrganisationContextStoreService } from '../../../services/stores/organisation-context-store.service';
import { CorporateFilters } from '../../../domain/corporate/corporate-filters';
import { Property } from '../../../domain/property';
import { CorporatePropertyAiSummary } from '../../../domain/Ai/corporate-property-ai-summary';
import { PortfolioSnapshotCardComponent } from '../portfolio-snapshot-card/portfolio-snapshot-card.component';
import { PortfolioSnapshot } from '../../../domain/corporate/portfolio-snapshot';
import { PortfolioRiskChartComponent } from '../portfolio-risk-chart/portfolio-risk-chart.component';
import { PortfolioRiskSeries } from '../../../domain/corporate/portfolio-risk-series';
import { HighRiskSectionComponent } from '../high-risk-section/high-risk-section.component';
import { Organisation } from '../../../domain/corporate/organisation';
import { PerformanceHotelsPanelComponent } from '../performance-hotels-panel/performance-hotels-panel.component';

@Component({
   selector: 'app-corporate-reporting-dashboard',
   standalone: true,
   imports: [
      CommonModule,
      CorporateFiltersBarComponent,
      PortfolioSnapshotCardComponent,
      PortfolioRiskChartComponent,
      HighRiskSectionComponent,
      PerformanceHotelsPanelComponent
   ],
   templateUrl: './corporate-reporting-dashboard.component.html',
   styleUrls: ['./corporate-reporting-dashboard.component.scss']
})
export class CorporateReportingDashboardComponent implements OnInit {
   organisations$!: Observable<Organisation[]>;
   organisationId$!: Observable<number | null>;
   properties$!: Observable<Property[]>;
   loading$!: Observable<boolean>;
   errorStatus$!: Observable<number | null>;
   filteredData$!: Observable<CorporatePropertyAiSummary[]>;
   snapshot$!: Observable<PortfolioSnapshot>;
   riskSeries$!: Observable<PortfolioRiskSeries>;
   highRiskHotelsCount$!: Observable<number>;
   highRiskReportsCount$!: Observable<number>;
   riskTitle$!: Observable<string>;

   constructor(
      private store: CorporateReportingStoreService,
      private orgContext: OrganisationContextStoreService,
      private route: ActivatedRoute
   ) {
      this.properties$ = this.store.properties$;
      this.loading$ = this.store.loading$;
      this.errorStatus$ = this.store.errorStatus$;
      this.filteredData$ = this.store.filteredData$;
      this.snapshot$ = this.store.snapshot$;
      this.riskSeries$ = this.store.riskSeries$;
      this.organisations$ = this.orgContext.organisations$;
      this.organisationId$ = this.orgContext.organisationId$;
      this.highRiskHotelsCount$ = this.store.highRiskHotelsCount$;
      this.highRiskReportsCount$ = this.store.highRiskReportsCount$;
      this.riskTitle$ = this.store.riskTitle$;
   }

   ngOnInit(): void {
      this.store.setFilters({
         propertyId: null,
         preset: 'last30',
         customStart: null,
         customEnd: null
      });
   }

   onOrganisationChanged(orgId: number | null): void {
      this.orgContext.setOrganisationId(orgId);
   }

   onFiltersChanged(filters: CorporateFilters): void {
      console.log('[CorporateDashboard] Filters changed:', filters);
      this.store.setFilters(filters);
   }
}
